import { reactive } from "vue";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
export const messages = reactive([]);
export function useVoixToast() {
  const defaultTimeout = 5e3;
  const remove = (messageId) => {
    const messageToRemove = messages.find((message) => message.id === messageId);
    if (!messageToRemove)
      return false;
    messages.splice(messages.indexOf(messageToRemove), 1);
  };
  class Message {
    id;
    msg;
    type;
    expires;
    timeout;
    // Milliseconds until the message expires
    constructor(id, msg, type, expires, timeout) {
      this.id = id;
      this.msg = msg;
      this.type = type;
      this.expires = expires;
      this.timeout = timeout;
      this.selfDestruct();
    }
    // Return the number of seconds until the message expires
    get timeLeft() {
      if (this.expires)
        return dayjs(this.expires).diff(dayjs(), "second");
      return null;
    }
    // Add time to the expiry date
    setExpires(newDate) {
      if (this.expires) {
        this.expires = newDate;
        return true;
      }
      return false;
    }
    selfDestruct = () => {
      const interval = setInterval(() => {
        if (dayjs(this.expires).isBefore(dayjs())) {
          remove(this.id);
          clearInterval(interval);
        }
      }, 250);
    };
  }
  const add = (msg, type, timeout) => {
    const messageId = uuidv4();
    let expires = null;
    if (timeout !== -1) {
      expires = dayjs().add(timeout || defaultTimeout, "millisecond").toDate();
    }
    const message = new Message(
      messageId,
      msg,
      type,
      expires,
      timeout || defaultTimeout
    );
    messages.push(message);
    return message;
  };
  return { messages, add, remove, defaultTimeout };
}
